import { BrandInfo, PageExtractor } from '../models';

const extractor = (pageHref: string, data: PageExtractor, brandInfo: BrandInfo): object => {
  const url = new URL(pageHref);

  return {
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageHref,
    },
    inLanguage: brandInfo.lang,
    author: {
      '@type': 'Person',
      name: data.author ? data.author : brandInfo.brandName,
    },
    publisher: {
      '@type': 'Organization',
      name: brandInfo.brandName,
      url: brandInfo.siteUrl,
      sameAs: brandInfo.sameAs,
      logo: {
        '@type': 'ImageObject',
        url: `${url.origin}/logo.png`,
      },
    },
  };
};

export default extractor;
